import React from 'react';
import { cn } from '../../utils/cn';

export interface AlertProps {
  type?: 'info' | 'success' | 'warning' | 'error';
  children: React.ReactNode;
  onClose?: () => void;
  action?: React.ReactNode;
  className?: string;
}

const Alert: React.FC<AlertProps> = ({
  type = 'info',
  children,
  onClose,
  action,
  className,
}) => {
  const styles: Record<string, string> = {
    info:    'bg-[var(--primary-50)] border-l-[var(--primary-200)] text-[var(--primary-900)]',
    success: 'bg-[var(--green-100)] border-l-[var(--green-500)] text-[var(--green-900)]',
    warning: 'bg-[var(--gold-100)] border-l-[var(--gold-500)] text-[var(--gold-900)]',
    error:   'bg-[#fee2e2] border-l-[var(--destructive)] text-[#991b1b]',
  };

  return (
    <div
      role="alert"
      className={cn(
        'border-l-[3px] rounded-md px-4 py-3 text-sm flex items-start gap-3',
        styles[type],
        className
      )}
    >
      <div className="flex-1">{children}</div>
      <div className="flex items-center gap-2 shrink-0">
        {action}
        {onClose && (
          <button
            onClick={onClose}
            className="text-current opacity-60 hover:opacity-100 transition-opacity"
            aria-label="Dismiss"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default Alert;
